import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalConfig";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";


async function startApp() {
  // ✅ REQUIRED
  await msalInstance.initialize();

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
     <GoogleOAuthProvider clientId="469337291016-uq7iuq02r2g77gdagb7ifkpi2qtcanb9.apps.googleusercontent.com">
      <MsalProvider instance={msalInstance}>
        <App />
        <ToastContainer position="top-right" />
      </MsalProvider>
    </GoogleOAuthProvider>
  );
}

startApp();
